import { useState, useEffect, useCallback } from 'react';
//import useDebounce from "@components/customHooks/useDebounce";
import AnimatedDonutChartCard from 'components/charts/AnimatedDonutChartCard';
import { Row, Col, Spinner /*, Button*/ } from 'react-bootstrap';
import { getProjectStats } from '@lib/api';
import StatusBar from '@components/StatusBar';
// import AnimatedHistogramChartCard from './AnimatedHistogramChartCard';
import { format } from 'date-fns';
import { formatToDecimals } from 'lib/helpers/formatting';
// import { ArrowDownUp } from 'icone';
import HistogramCards from './HistogramCards';
import { useQuery } from '@tanstack/react-query';

const DashboardWheelsSection = ({ projectId, global, setSummaryWheelsValues }) => {
	// const [projectStats, setProjectStats] = useState({});
	const [wheelsValues, setWheelsValues] = useState([]);
	// const [isLoading, setIsLoading] = useState(false);
	const [percentageFirstDonut, setPercentageFirstDonut] = useState(0);
	const [percentageSecondDonut, setPercentageSecondDonut] = useState(0);
	const [, /* sbShow */ setSbShow] = useState(<></>);

	const handleStatusBar = useCallback((status, message, timeout) => {
		setSbShow(<StatusBar status={status} message={message} timeout={timeout} />);
	}, []);

	/* useDebounce(
  /* useDebounce(
    () => {
      fetchData();
    },
    500,
    [projectId, global]
  ); */

	// useEffect(() => {
	// 	if (projectId !== undefined || global === true) {
	// 		fetchData();
	// 	}
	// }, [projectId, global]); // eslint-disable-line react-hooks/exhaustive-deps

	// const fetchData = useCallback(
	// 	async (e) => {
	// 		try {
	// 			setIsLoading(true);
	// 			const apiProjectId = global === true ? '' : projectId;
	// 			const retrievedStats = await getProjectStats(apiProjectId);
	// 			if (!retrievedStats.success) {
	// 				let message = retrievedStats.message.length
	// 					? retrievedStats.message
	// 					: 'Si è verificato un errore durante il caricamento delle informazioni.';
	// 				throw new Error(message);
	// 			}
	// 			setProjectStats(retrievedStats.data);
	// 		} catch (error) {
	// 			handleStatusBar('error', error.message, false);
	// 		} finally {
	// 			setIsLoading(false);
	// 		}
	// 	},
	// 	[global, handleStatusBar, projectId],
	// );

	const { data: projectStats, isPending } = useQuery({
		queryKey: ['projectStats', projectId, global],
		queryFn: async () => {
			const apiProjectId = global === true ? '' : projectId;
			const retrievedStats = await getProjectStats(apiProjectId);
			if (!retrievedStats.success) {
				let message = retrievedStats.message.length
					? retrievedStats.message
					: 'Si è verificato un errore durante il caricamento delle informazioni.';
				throw new Error(message);
			}
			return retrievedStats.data;
		},
		enabled: projectId !== undefined || global === true,
		onError: (error) => {
			handleStatusBar('error', error.message, false);
		},
		refetchOnMount: false,
	});

	function defaultHistogramDataFilter(data) {
		const filteredData = {};

		data.forEach((item) => {
			if (item.propertyName === 'reportedAmount' || item.propertyName === 'requestedAmount') {
				filteredData[item.propertyName] = {
					label: item.translation,
					value: item.realValue,
					color: item.color,
					tooltip: item.tooltip,
				};
			}
		});
		filteredData['reportedAmount'].tooltip =
			'Rendicontato - ' +
			formatToDecimals(data.find((item) => item.propertyName === 'reportedAmount')?.realValue) +
			' € di cui <br/>' +
			'Costi reali rendicontati - ' +
			formatToDecimals(
				data.find((item) => item.propertyName === 'reportedAmount')?.realValue -
					data.find((item) => item.propertyName === 'reportedIndirectCost')?.realValue,
			) +
			' € <br/>' +
			'Costi indiretti rendicontati - ' +
			formatToDecimals(data.find((item) => item.propertyName === 'reportedIndirectCost')?.realValue) +
			' €';

		filteredData['requestedAmount'].tooltip =
			'Richiesto - ' + formatToDecimals(data.find((item) => item.propertyName === 'requestedAmount')?.realValue) + ' €';

		const emptyElement = {
			value: 0,
			color: 'transparent',
			tooltip: '',
		};

		filteredData['empty_0'] = {
			...emptyElement,
			label: 'empty_0',
		};
		filteredData['empty_1'] = {
			...emptyElement,
			label: 'empty_1',
		};

		return filteredData;
	}
	function detailsHistogramDataFilter(data) {
		const filteredData = {};

		data.forEach((item) => {
			if (
				item.propertyName === 'requestedAmount' ||
				item.propertyName === 'cashedIn' ||
				item.propertyName === 'reportedIndirectCost' ||
				item.propertyName === 'advanceCashedIn' ||
				item.propertyName === 'totalApprovedAmount' ||
				item.propertyName === 'notApproved'
			) {
				filteredData[item.propertyName] = {
					label: item.translation,
					value: item.realValue,
					color: item.color,
					tooltip: item.tooltip,
				};
			}
		});

		filteredData['requestedAmount'].tooltip =
			'Richiesto - ' + formatToDecimals(data.find((item) => item.propertyName === 'requestedAmount')?.realValue) + ' €';

		filteredData['totalApprovedAmount'].tooltip =
			'Approvato - ' + formatToDecimals(data.find((item) => item.propertyName === 'totalApprovedAmount')?.realValue) + ' €';

		filteredData['cashedIn'].tooltip =
			'Incassato - ' +
			formatToDecimals(data.find((item) => item.propertyName === 'cashedIn')?.realValue) +
			' € di cui <br/>' +
			'Anticipo - ' +
			formatToDecimals(data.find((item) => item.propertyName === 'advanceCashedIn')?.realValue) +
			' €';

		filteredData['notApproved'].tooltip =
			'Non approvato - ' + formatToDecimals(data.find((item) => item.propertyName === 'notApproved')?.realValue) + ' €';
		return filteredData;
	}

	const objectToArray = useCallback(
		(obj, setState) => {
			const translatedPropertyNames = {
				totalAmount: { name: 'Totale investimento', color: '', position: 1 },
				finalAmount: {
					name: 'Spesa effettuata',
					color: '#C2C923',
					position: 3,
				},
				quotaAmount: {
					name: 'Importo della Quota',
					color: '#08A2AA',
					position: 2,
				},
				selfFinancedAmount: {
					name: 'Mezzi propri',
					color: '#08A2AA',
					position: 4,
				},
				//
				reportedAmount: {
					name: 'Rendicontato',
					color: '#C2C923',
					position: 5,
					tooltip: 'Qualora applicate, nella quota sono comprese le spese generali',
				},
				requestedAmount: {
					name: 'Richiesto',
					color: '#08A2AA',
					position: 6,
				},
				reportableNotReportedAmount: {
					name: 'Rendicontabile',
					color: '#C2C923',
					position: 7,
				},
				notReportableNotReportedAmount: {
					name: 'In lavorazione',
					color: '#FFB317',
					position: 8,
				},
				notSpent: {
					name: 'Spesa da effettuare',
					color: '#08A2AA',
					position: 9,
				},
				//
				totalApprovedAmount: {
					name: 'Approvato',
					color: '#374D84',
					position: 10,
				},
				cashedIn: {
					name: 'Incassato',
					color: '#008055',
					position: 11,
				},
				compliantAmount: { name: 'Eleggibile', color: '#C2C923', position: 12 },
				inProgressAmount: {
					name: 'In lavorazione',
					color: '#08A2AA',
					position: 13,
				},
				notCompliantAmount: {
					name: 'Non eleggibile',
					color: '#666666',
					position: 14,
				},

				empty: { name: '', color: '', position: 15 },

				notApproved: { name: 'Non approvato', color: '#CC334D' },
			};

			const result = Object.keys(obj).map((key) => {
				let total;

				switch (key) {
					case 'finalAmount':
					case 'notSpent':
						total = obj.totalAmount;
						break;
					case 'compliantAmount':
					case 'notCompliantAmount':
					case 'inProgressAmount':
						total = obj.finalAmount;
						break;
					default:
						total = obj.totalAmount;
						break;
				}

				const percentageTotalValue = total / 100;

				let propertyValue = obj[key] < percentageTotalValue && obj[key] !== 0 ? obj[key] + percentageTotalValue : obj[key];

				return {
					propertyName: key,
					propertyValue: propertyValue,
					realValue: translatedPropertyNames[key]?.compute ? translatedPropertyNames[key]?.compute(obj) : obj[key],
					translation: translatedPropertyNames[key]?.name,
					color: translatedPropertyNames[key]?.color,
					position: translatedPropertyNames[key]?.position,
					tooltip: translatedPropertyNames[key]?.tooltip,
				};
			});

			const notSpent = obj.totalAmount - obj.finalAmount;

			result.push({
				propertyName: 'notSpent',
				propertyValue: notSpent,
				realValue: notSpent,
				translation: translatedPropertyNames.notSpent.name,
				color: translatedPropertyNames.notSpent.color,
				position: translatedPropertyNames.notSpent.position,
			});

			const notApproved = obj.requestedAmount - obj.totalApprovedAmount;

			result.push({
				propertyName: 'notApproved',
				propertyValue: notApproved,
				realValue: notApproved,
				translation: translatedPropertyNames.notApproved.name,
				color: translatedPropertyNames.notApproved.color,
				position: translatedPropertyNames.notApproved.position,
			});

			const reportedAmountWithIndirectCost = obj.reportedAmount + obj.reportedIndirectCost;
			result.find((item) => item.propertyName === 'reportedAmount').realValue = reportedAmountWithIndirectCost;

			const empty = '';

			result.push({
				propertyName: 'empty',
				propertyValue: empty,
				realValue: empty,
				translation: translatedPropertyNames.empty.name,
				color: translatedPropertyNames.empty.color,
				position: translatedPropertyNames.empty.position,
			});

			setPercentageFirstDonut(isNaN((obj.finalAmount * 100) / obj.totalAmount) ? 0 : (obj.finalAmount * 100) / obj.totalAmount);
			setPercentageSecondDonut(isNaN((obj.compliantAmount * 100) / obj.finalAmount) ? 0 : (obj.compliantAmount * 100) / obj.finalAmount);

			setState(result);
			if (setSummaryWheelsValues) {
				setSummaryWheelsValues(result);
			}
		},
		[setSummaryWheelsValues],
	);

	useEffect(() => {
		if (projectStats && Object.keys(projectStats).length) {
			objectToArray(projectStats, setWheelsValues);
		}
	}, [projectStats, objectToArray]);

	function filterArrayByValues(arr, targetValues, withNull = true) {
		const test = arr
			.filter((item) => {
				const isTarget = targetValues.includes(item.propertyName);
				const isNonZero = item.propertyValue !== 0;
				return withNull ? isTarget && isNonZero : isTarget;
			})
			.sort((a, b) => a.position - b.position);

		return test;
	}

	return (
		<>
			<Row className="flex-wrap justify-content-around align-items-stretch" style={{ columnGap: '1%' }}>
				<Col>
					<div className={`simple-box scenaritab ${global ? 'card-chart' : 'card-chart-project'} ${isPending ? '' : 'minheight'}`}>
						{!isPending && wheelsValues.length ? (
							<>
								<AnimatedDonutChartCard
									chartId="dashDon_0"
									donutData={wheelsValues && filterArrayByValues(wheelsValues, ['finalAmount', 'notSpent'])}
									cardData={filterArrayByValues(wheelsValues, ['finalAmount', 'notSpent', 'empty'], false)}
									labelOnHover={true}
									totalName="totalAmount"
									title={'Avanzamento (€)'}
									code={global ? 'avanzamentoGlobal' : 'avanzamentoProject'}
									valueInCircle={percentageFirstDonut}
								/>
								{projectId ? (
									<div style={{ fontSize: '14px', marginTop: '16px' }}>
										<div className="d-flex justify-content-between flex-column flex-xxl-row">
											<div className="d-flex justify-content-between d-xxl-block">
												<span className="f-600">Ultimo caricamento costi esterni: </span>
												{projectStats.lastDateFtImport ? format(projectStats.lastDateFtImport, 'dd/MM/yyyy') : 'N.D.'}
											</div>
											<div className="d-flex justify-content-between d-xxl-block text-xxl-end">
												<span className="f-600">Nº SAL: </span>
												{projectStats.lastSalFt || 'N.D.'}
											</div>
										</div>
										<div className="d-flex justify-content-between flex-column flex-xxl-row">
											<div className="d-flex justify-content-between d-xxl-block">
												<span className="f-600">Ultimo caricamento costi interni: </span>
												{projectStats.lastDateTsImport ? format(projectStats.lastDateTsImport, 'dd/MM/yyyy') : 'N.D.'}
											</div>
											<div className="d-flex justify-content-between d-xxl-block text-xxl-end">
												<span className="f-600">Nº SAL: </span>
												{projectStats.lastSalTs || 'N.D.'}
											</div>
										</div>
									</div>
								) : null}
							</>
						) : (
							<div className="text-center">
								<Spinner animation="border" role="status" variant="dark">
									<span className="visually-hidden">Loading...</span>
								</Spinner>
							</div>
						)}
					</div>
				</Col>
				<Col>
					<div className={`simple-box scenaritab card-chart ${isPending ? '' : 'minheight'}`}>
						{!isPending && wheelsValues.length ? (
							<>
								<AnimatedDonutChartCard
									chartId={'dashDon_1'}
									donutData={filterArrayByValues(wheelsValues, ['compliantAmount', 'notCompliantAmount', 'inProgressAmount'])}
									cardData={filterArrayByValues(wheelsValues, ['compliantAmount', 'notCompliantAmount', 'inProgressAmount'], false)}
									labelOnHover={true}
									shouldDifference={true}
									totalName="totalAmount"
									title={'Controllo (€)'}
									code={'controllo'}
									valueInCircle={percentageSecondDonut}
								/>
								{projectId ? (
									<>
										<div style={{ height: '64px' }} />
										<div className="d-xxl-none" style={{ height: '48px' }} />
									</>
								) : null}
							</>
						) : (
							<div className="text-center">
								<Spinner animation="border" role="status" variant="dark">
									<span className="visually-hidden">Loading...</span>
								</Spinner>
							</div>
						)}
					</div>
				</Col>
				<Col>
					<div className={`simple-box scenaritab card-chart ${isPending ? '' : 'minheight'}`}>
						{!isPending && wheelsValues.length ? (
							<HistogramCards
								standard={{
									data: defaultHistogramDataFilter(wheelsValues),
									order: ['empty_0', 'reportedAmount', 'requestedAmount', 'empty_1'],
									cardData: filterArrayByValues(wheelsValues, ['reportedAmount', 'requestedAmount'], false),
								}}
								details={{
									data: detailsHistogramDataFilter(wheelsValues),
									order: ['requestedAmount', 'totalApprovedAmount', 'cashedIn', 'notApproved'],
									cardData: filterArrayByValues(wheelsValues, ['requestedAmount', 'totalApprovedAmount', 'cashedIn', 'notApproved'], false),
								}}
								lastStatementRender={(activeHistogram) =>
									projectId ? (
										<>
											<div
												className="d-flex justify-content-between flex-column flex-xxl-row"
												style={{
													fontSize: '14px',
													// N.D.R. adds some margin
													// to match the height of
													// the other cards
													marginBottom: activeHistogram === 'standard' ? '45.4px' : '40.6px',
												}}
											>
												<div className="d-flex justify-content-between d-xxl-block">
													<span className="f-600">Ultima rendicontazione:</span>
													{projectStats.lastDateStatement ? format(projectStats.lastDateStatement, 'dd/MM/yyyy') : 'N.D.'}
												</div>
												<div className="d-flex justify-content-between d-xxl-block text-xxl-end">
													<span className="f-600">Nº SAL: </span>
													{projectStats.lastSalStatement || 'N.D.'}
												</div>
											</div>
										</>
									) : (
										// N.D.R. adds a spacer
										// to match the height of
										// the other cards
										<div style={{ height: '0.6px' }} />
									)
								}
							/>
						) : (
							<div className="text-center">
								<Spinner animation="border" role="status" variant="dark">
									<span className="visually-hidden">Loading...</span>
								</Spinner>
							</div>
						)}
					</div>
				</Col>
			</Row>
		</>
	);
};

export default DashboardWheelsSection;
